// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"118":"a1f06c32","374":"7a007693","449":"75769e07","489":"8840f64f","564":"0cda7412","805":"69d10da6"}[chunkId] + ".css";
};